import { render, staticRenderFns } from "./DodajCertifikateIP.vue?vue&type=template&id=4fe2e8f3&scoped=true&"
import script from "./DodajCertifikateIP.vue?vue&type=script&lang=js&"
export * from "./DodajCertifikateIP.vue?vue&type=script&lang=js&"
import style0 from "./DodajCertifikateIP.vue?vue&type=style&index=0&id=4fe2e8f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe2e8f3",
  null
  
)

export default component.exports